// extracted by mini-css-extract-plugin
export default {"sapcnqr-screen-reader-message":"sapcnqr-screen-reader-message-ba3477"};